import React, {Component} from 'react';
import {AgGridReact} from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {connect} from "react-redux";
import {
  editWaterfallSchemas,
  emptyEditFinStructure,
  getFinancicalSchemaById,
  setFinSchemaError
} from "../../../store/actions";
import CustomIconsAgGrid from "./FieldRenderer/CustomIconsAgGrid";
import ColDef from "ag-grid-community";
import SimpleInputAgGridRenderer from "./FieldRenderer/SimpleInputAgGridRenderer";
import SimpleInputAgGridEditor from "./FieldRenderer/SimpleInputAgGridEditor";
import CheckboxAgGridEditor from "../../Projects/Projects/FieldRenderer/CheckboxAgGridEditor";

class FinStrAgGrid extends Component {
  state = {
    rowData: [],
    colDef: [],
    frameworkComponents: {
      customIcons: (params) => <CustomIconsAgGrid params={params}/>,
      simpleInputAgGridRenderer: SimpleInputAgGridRenderer,
      simpleInputAgGridEditor: SimpleInputAgGridEditor,
      checkboxAgGridEditor: CheckboxAgGridEditor,
    },
    cellRendererSelector: ColDef,
    cellEditorSelector: ColDef,
  };

  componentDidMount() {
    const {finStrData, getFinancicalSchemaById, emptyEditFinStructure,finStrIndex,finSchemaNew,financicalSchemasTemplates,name} = this.props;

    if(!finSchemaNew){
      emptyEditFinStructure();
      getFinancicalSchemaById(finStrData.id).then((res) => {
        const {waterfall_items, fin_structure} = res.payload;
        let rowObj = {};
        let colDef = [{
          headerName: '',
          field: 'inputType',
          width: 150,
          editable: false,
          finStrIndex,
          finStrData: res.payload,
          cellRendererSelector: () => {
            return {
              component: 'customIcons',
              params: {id: fin_structure.id,}
            };
          },
        }];

        waterfall_items.map((item, j) => {
          const keys = Object.keys(item.data);
          const values = Object.values(item.data);
          keys.map((key, i) => {
            rowObj[key + j] = values[i].value;
            colDef.push({
              headerName: key,
              field: key + j,
              editable: true,
              cellRendererSelector: () => {
                const {type} = values[i];
                if (type !== 'boolean') {
                  return {component: 'simpleInputAgGridRenderer', params: {id: fin_structure.id}}
                }
                return null;
              },
              cellEditorSelector: (params) => {
                const {type} = values[i];
                if (type !== 'boolean') {
                  return {
                    component: 'simpleInputAgGridEditor',
                    params: {id: fin_structure.id, type, required: item.required.includes(key) ? true : false}
                  }
                }
                return {component: 'checkboxAgGridEditor', params};
              }
            });
          });
        });
        this.setState({rowData: [rowObj], colDef})
      })
    }else {
      let rowObj = {};
      let colDef = [{
        headerName: '',
        field: 'inputType',
        width: 150,
        editable: false,
        finStrData:financicalSchemasTemplates,
        finStrName: name,
        cellRendererSelector: () => {
          return {
            component: 'customIcons',
            params: {id: -1,}
          };
        },
      }];
      financicalSchemasTemplates.waterfall_items_details.map((item, j) => {
        const keys = Object.keys(item.waterfall_item_data.properties);
        const values = Object.values(item.waterfall_item_data.properties);
        keys.map((key, i) => {
          if(values[i].type === 'boolean'){
            rowObj[key + j] = values[i].default;
          } else {
            rowObj[key + j] = values[i].default ?  values[i].default :  '';
          }
          colDef.push({
            headerName: key,
            field: key + j,
            editable: true,
            cellRendererSelector: () => {
              const {type} = values[i];
              if (type !== 'boolean') {
                return {component: 'simpleInputAgGridRenderer', params: {id: -1}}
              }
              return null;
            },
            cellEditorSelector: (params) => {
              const {type} = values[i];
              if (type !== 'boolean') {
                return {
                  component: 'simpleInputAgGridEditor',
                  params: {id: -1, type, required: item.waterfall_item_data.required
                    && item.waterfall_item_data.required.includes(key) ? true : false}
                }
              }
              return {component: 'checkboxAgGridEditor', params};
            }
          });
        });
      });
      this.setState({rowData: [rowObj], colDef})
    }
  }

  render() {
    const {colDef, rowData, frameworkComponents} = this.state;
    const {setFinSchemaError,isOpenTabIndexChange} = this.props;

    return (
      <div style={{height: '400px'}}>
        <AgGridReact
          enableSorting={true}
          enableFilter={true}
          columnDefs={colDef}
          rowData={rowData}
          isOpenTabIndexChange={isOpenTabIndexChange}
          rowSelection="single"
          setFinSchemaError={setFinSchemaError}
          frameworkComponents={frameworkComponents}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    schemasTemplates: state,
    schema: state.schemas,
    name: state.schemas.name,
    finSchema: state.financicalSchemas.finSchema,
    financicalSchemasTemplates: state.financicalSchemas.financicalSchemasTemplates
  };
};

export default connect(
  mapStateToProps,
  {
    emptyEditFinStructure,
    editWaterfallSchemas,
    getFinancicalSchemaById,
    setFinSchemaError,
  })(FinStrAgGrid);


// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/FinStrAgGrid.js